import { render, staticRenderFns } from "./QueryResult.vue?vue&type=template&id=3f80d3b6&scoped=true&"
import script from "./QueryResult.vue?vue&type=script&lang=js&"
export * from "./QueryResult.vue?vue&type=script&lang=js&"
import style0 from "./QueryResult.vue?vue&type=style&index=0&id=3f80d3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80d3b6",
  null
  
)

component.options.__file = "QueryResult.vue"
export default component.exports